export default "__VITE_ASSET__CpXFO1pq__"